export const onlyNumbersRegex = /^\d+$/;

export const CHANGE_VALUES = {
  ADD: 'add',
  SUBTRACT: 'subtract',
} as const;
